import { useGetCustomStyles } from 'api/hooks';
import * as React from 'react';
import './Footer.css';

export const Footer = () => {
  const { customStyles, customStylesError, customStylesLoading } = useGetCustomStyles();
  // Fall back to the default image if we cannot find the selected image for any reason.
  let [cardImage, setCardImage] = React.useState<JSX.Element>(
    <img
      className='w-10 h-10 rounded-lg'
      src={customStyles?.logoUrl}
      alt=''
      onError={() => setCardImage(<div></div>)}
    />
  );
  React.useEffect(() => {
    setCardImage(
      <img
        className='w-10 h-10 rounded-lg'
        src={customStyles?.logoUrl}
        alt=''
        onError={() => setCardImage(<div></div>)}
      />
    );
  }, [customStylesLoading]);
  return (
    <div
      className='main-container-footer'
      style={{
        ...(!!customStyles && {
          backgroundColor: `${customStyles.customStyling?.backgroundColor}`
        })
      }}>
      <div className='footer-logo-holder'>{cardImage}</div>
    </div>
  );
};
